import React from 'react';
import Slick from 'react-slick';

import './slider.module.scss';

import {
    ArrowLeftIcon,
	ArrowRightIcon
} from './icons';

const NextArrow = ({ className, onClick }) => (
	<button 
		onClick={onClick}
		className={className}>
		<ArrowRightIcon />
	</button>
);

const PrevArrow = ({ className, onClick }) => (
	<button 
		onClick={onClick}
		className={className}>
		<ArrowLeftIcon />
	</button>
);

const Slider = (props) => {
	const { children } = props;

	const defaultProps = {
		dots: false,
		lazyLoad: true,
      	infinite: true,
      	slidesToShow: 1,
      	slidesToScroll: 1,
      	nextArrow: <NextArrow />,
      	prevArrow: <PrevArrow />
	}

	props = {
		...defaultProps,
		...props,
		...{
			children: undefined
		}
	};

	return (
		<div className={`${props.dots && 'slick-dotted'}`}>
			<Slick 
				{...props}>
				{children}
			</Slick>
		</div>
	);
};



export default Slider;